module.exports = __webpack_public_path__ + "img/Postmodernisme_Triztan-Vindtorn.ca5545d9.jpg";